module.exports = __webpack_public_path__ + "img/p10.8266c21b.svg";